const initialState = {
    madarsa: null,
    banners: [],
    institutions: [],
    donation_info: null,
    selectedInstitution: null,
    ourWork: [],
    loading: false
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SITE_DATA':
            return {
                ...state,
                madarsa: action.payload.madarsa,
                banners: action.payload.banners,
                institutions: action.payload.institutions,
                donation_info: action.payload.donation_info,
            }
        case 'SET_SELECTED_INSTITUTION':
            return {
                ...state,
                selectedInstitution: action.payload
            }
        case 'SET_OUR_WORK':
            return {
                ...state,
                ourWork: action.payload
            }
        case 'SET_LOADING':
            return {
                ...state,
                loading: action.payload
            }
        default:
            return state;
    }
};

export default reducer;